var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgReportSid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.98383 6.0869C8.40287 6.0869 7.92945 5.61349 7.92945 5.03253V0.815025H1.6032C1.02224 0.815025 0.548828 1.28844 0.548828 1.8694V16.6307C0.548828 17.2127 1.02224 17.685 1.6032 17.685H12.147C12.729 17.685 13.2013 17.2127 13.2013 16.6307V6.0869H8.98383ZM4.76633 15.5763H2.65758V12.4132H4.76633V15.5763ZM7.92945 15.5763H5.8207V10.3044H7.92945V15.5763ZM11.0926 15.5763H8.98383V8.19565H11.0926V15.5763Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportSid);
export default __webpack_public_path__ + "static/media/reportSid.c9c231700a0f1e14ce07ae9a266107ca.svg";
export { ForwardRef as ReactComponent };